export default __webpack_public_path__ + "../staticImages/tapas-260.png";